import React, { useState, useEffect } from 'react';
import Header from "components/Headers/Header.js";
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Card, CardHeader, CardBody, Container, Row, Col, Spinner, Table, CardFooter, Pagination, PaginationItem, PaginationLink, Button } from "reactstrap";
import { Form } from 'react-bootstrap';
import { format } from 'date-fns';
import {Link} from 'react-router-dom'
import * as XLSX from 'xlsx';

function InsuranceTable() {

  const [loading, setLoading] = useState(true);
  const [sensorsoptions, setSensorsoptions] = useState([]);
  const [sensors, setSensor] = useState('');
  const [dateoptions, setDateoptions] = useState([]);
  const [date, setDate] = useState('');
  const [sensordata, setSensordata] = useState([]);
  
  const token = useSelector((state) => state.userLogin.userInfo.token);
  const { t, i18n } = useTranslation();

  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(5); // Default rows per page
  const totalPages = Math.ceil(sensordata.length / pageSize);
  const startIndex = currentPage * pageSize;
  const endIndex = Math.min(startIndex + pageSize, sensordata.length);
  const paginatedData = sensordata.slice(startIndex, endIndex);

  const [loadingsubmit, setLoadingsubmit] = useState(true)

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const storedLanguage = localStorage.getItem('selectedLanguageAFS');
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  }, [i18n]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const config = {
          headers: {
            'Content-type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        };

        const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/sensor-list/`, config);
        setSensorsoptions(response.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token]);

  const handleSelectChange1 = async (e) => {
    setSensor(e.target.value);
    const sensorselected = e.target.value;

    try {
      const config = {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      };

      const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/date-sensor-data-acquisition/${sensorselected}`, config);
      setDateoptions(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSelectChange2 = async (e) => {
    setDate(e.target.value);
    const dateselected = e.target.value;

    try {
      const config = {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      };

      const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/sensor-data-by-date/${sensors}/${dateselected}`, config);
      setSensordata(response.data);
      console.log(response.data)
      setCurrentPage(0); // Reset pagination when new data is fetched
    } catch (error) {
      console.error(error);
    }
  };

  const handleDownload = async (e) => {
    setLoadingsubmit(false); // Start loading

    try {

      const filteredData = sensordata.map(({ id_sensor, 
                                              id_acquisition, 
                                              x_coord, 
                                              y_coord,
                                              z_coord,
                                              date,
                                              crop,
                                              count,
                                              width,
                                              height,
                                              area}) => ({
      id_sensor, 
      id_acquisition, 
      x_coord, 
      y_coord,
      z_coord,
      date,
      crop,
      count,
      width,
      height,
      area
      }));

      const worksheet = XLSX.utils.json_to_sheet(filteredData);

      // Create a workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "SensorData");

      // Generate Excel file and trigger download
      XLSX.writeFile(workbook, "SensorData.xlsx");
    } catch (error) {
      console.error("Error while downloading Excel:", error);
    } finally {
      setLoadingsubmit(true); // End loading
    }
  };

  return (
    <div>
      <Header/>
      {loading ? (
        <Container className="mt--15" fluid>
          <Row>
            <Col className="text-center mt-5">
              <Spinner>{t('Loading')}</Spinner>
            </Col>
          </Row>
        </Container>
      ) : (
        <>
          <Container className="mt--15" fluid>
            <Row>
              <Col vxs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                <Card>
                  <CardHeader style={{ textAlign: 'center' }}>
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                        <h3>{t('Table of the Data')}</h3>
                      </Col>
                      <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
                        <Form.Group>
                          <Form.Label>{t('Select the sensor')}</Form.Label>
                          <Form.Control as="select" onChange={handleSelectChange1} value={sensors}>
                            <option value=""></option>
                            {sensorsoptions.map((sensor, index) => (
                                <option key={index} value={sensor.id}>
                                  {sensor.first_name} {" "} {sensor.last_name} {" "} {sensor.email} {" - Sensore "} {sensor.id_sensor}
                                </option>
                            ))}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
                        <Form.Group>
                          <Form.Label>{t('Select the date')}</Form.Label>
                          <Form.Control as="select" onChange={handleSelectChange2} value={date}>
                              <option value=""></option>
                              {dateoptions.map((option, index) => (
                                  <option key={index} value={option.date}>{format(new Date(option.date), 'PPpp')}</option>
                              ))}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
                        <Form.Group>
                          <Form.Label>{t('Pagination')}</Form.Label>
                          <Form.Control 
                            as="select" 
                            onChange={(e) => setPageSize(e.target.value)}
                            value={pageSize}>
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="30">30</option>
                            <option value="100">100</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    {paginatedData.length > 0 ? (
                      <>
                        <Table className="align-items-center table-flush text-center" responsive>
                          <thead className="thead-light">
                            <tr>
                              <th>{t('Date')}</th>
                              <th>{t('Crop')}</th>
                              <th>{t('Grape Number')}</th>
                              <th>{t('Mean Grape Area')}</th>
                              <th>{t('Mean Height Grape')}</th>
                              <th>{t('Mean Width Grape')}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {paginatedData.map((data, index) => (
                              <tr key={index}>
                                <td>{format(new Date(data.date), 'PPpp')}</td>
                                <td>{data.crop}</td>
                                <td>{data.count}</td>
                                <td>{data.area}</td>
                                <td>{data.height}</td>
                                <td>{data.width}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                        <Pagination aria-label="Page navigation">
                          <PaginationItem disabled={currentPage <= 0}>
                            <PaginationLink previous onClick={() => handlePageChange(currentPage - 1)} />
                          </PaginationItem>
                          {[...Array(totalPages)].map((_, i) => (
                          <PaginationItem key={i} active={i === currentPage}>
                            <PaginationLink onClick={() => handlePageChange(i)}>{i + 1}</PaginationLink>
                          </PaginationItem>
                          ))}
                          <PaginationItem disabled={currentPage >= totalPages - 1}>
                            <PaginationLink next onClick={() => handlePageChange(currentPage + 1)} />
                          </PaginationItem>
                        </Pagination>
                      </>
                    ) : (
                      <p>{t('No data available')}</p>
                    )}
                  </CardBody>
                  <CardFooter>
                    <Row>
                      <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                        {loadingsubmit ? (
                          <>
                            <Button color="success" onClick={handleDownload}>
                              {t('Download Selected Data')} <i class="fa-solid fa-cloud-arrow-down"></i>
                            </Button>
                          </>
                        ):(
                          <>
                            <Button color="success" disabled>
                              <Spinner size="sm">
                                {t('Downloading Selected Data...')}
                              </Spinner>
                              <span>
                                {' '}{t('Downloading Selected Data...')}
                              </span>
                            </Button>
                          </>
                        )}
                      </Col>
                      <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                        <Link to="/">
                          <Button color="primary">
                            {t('Go back')} <i className="fas fa-rotate-left"></i>
                          </Button>
                        </Link>
                      </Col>
                    </Row>
                  </CardFooter>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      )}
    </div>
  )
}

export default InsuranceTable
